import React from 'react';
import { reduxForm, Field } from 'redux-form';
import FormField from '../../forms/FormField';

const required = value => value ? undefined : 'Required';

const ForgotPasswordForm = props => {
  const { handleSubmit, submitting, passwordError } = props;
  return (
    <form onSubmit={handleSubmit}>
      <Field
        name="email"
        type="text"
        component={FormField.Input}
        placeholder="Email Address"
        validate={[required]}
      />
      <div>
        <div className="form-row">
          <div className="col-md-12">
            <button
              type="submit"
              className="btn btn-primary"
              disabled={submitting}
            >
              Submit
            </button>
            {passwordError && (
              <span style={{ color: '#dc3545', marginLeft: '20px' }}>
                An error occurred.
              </span>
            )}
          </div>
        </div>
      </div>
    </form>
  );
};

export default reduxForm({
  form: 'forgot-password-form'
})(ForgotPasswordForm);
